import { getEnvironmentParam } from '../../../../environments/helper';

export const skipLocationChange = false;

export enum SlackChannelType {
  member = 'member',
  private_channel = 'private_channel',
  channel = 'channel'
}
